var locationGeocoder = new google.maps.Geocoder();
function initialize(id, callback) {
    var input = /** type {!HTMLInputElement} */(
        document.getElementById(id));
    if (input) {
        var autocomplete = new google.maps.places.Autocomplete(input, {
           types: ['locality', 'postal_code'],
            componentRestrictions: { country: 'us' }
        });

        autocomplete.addListener('place_changed', function () {
            var place = autocomplete.getPlace();
            if (!place.geometry) {
                return;
            }
            var location = place.geometry.location;
            callback(location);
        });

        return autocomplete;
    }
}

// Expose functions globally
window.initialize = initialize;

function pinSymbol(color) {
    return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: '#000',
        strokeWeight: 2,
        scale: 1,
    };
}

// Expose pinSymbol globally
window.pinSymbol = pinSymbol;


//  http://stackoverflow.com/questions/14560999/using-the-haversine-formula-in-javascript
// coords = [long, lat]
function haversineDistance(coords1, coords2, isMiles) {
    function toRad(x) {
        return x * Math.PI / 180;
    }

    var lon1 = coords1[0];
    var lat1 = coords1[1];

    var lon2 = coords2[0];
    var lat2 = coords2[1];

    var R = 6371; // km

    var x1 = lat2 - lat1;
    var dLat = toRad(x1);
    var x2 = lon2 - lon1;
    var dLon = toRad(x2)
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;

    if (isMiles) d /= 1.60934;

    return d;
}

function noResults(searchValue) {
    cleanLocationCookies();
    window.location.href = '/patient-resources/find-a-location/locations-search-result/?search=' + encodeURI(searchValue) + "#contentTop";
}

function cleanSearch(value) {
    if (value) {
        return encodeURIComponent(value.trim().replace('&', '').replace('?', '').replace('*', ''));
    }
    else {
        return value;
    }
}

function cleanLocationCookies() {

    Cookies.remove("locSort");
    Cookies.remove("locViewAmount");
    Cookies.remove("locDistance");

}


function handleLocationSearch(searchValue) {
    searchValue = searchValue.trim();

    if (searchValue == "") {
        alert('Please enter a valid location.');
        return false;
    }
    else {

        //    see if the database has a location of this name

        $.ajax({
            method: "POST",
            url: "/umbraco/api/location/search",
            data: { value: searchValue }
        })
            .done(function (locations) {


                if (locations && locations.locations && locations.locations.length) {
                    //  have results, so forward to the results page
                    cleanLocationCookies();
                    window.location.href = '/patient-resources/find-a-location/locations-search-result/?search=' + encodeURI(searchValue) + "#contentTop";

                }
                else {
                    //  no results, so use the goog

                    locationGeocoder.geocode({ 'address': searchValue }, function (results, status) {
                        if (status == 'OK') {

                            var lat = results[0].geometry.location.lat();
                            var lng = results[0].geometry.location.lng();


                            var hospitalLat = 40.735553;
                            var hospitalLong = -84.085809;
                            //  see if distance is over 100 miles from lima

                            var distance = haversineDistance([hospitalLong, hospitalLat], [lng, lat], true);

                            if (distance > 100) {
                                //  show friendly no-results somehow
                                noResults(searchValue);
                            }
                            else {
                                cleanLocationCookies();
                                window.location.href = '/patient-resources/find-a-location/locations-search-result/' + lat + '/' + lng + '?search=' + encodeURI(searchValue) + "#contentTop";
                            }

                        } else {
                            noResults(searchValue);
                        }

                    });
                }

            }).fail(function (jqXHR, textStatus) {
                noResults(searchValue);
            });

    }
}

function handleLocationTypeSearch(locationTypeValue) {
    locationTypeValue = locationTypeValue.trim();
    if (locationTypeValue == "" || locationTypeValue == "empty") {
        alert('Please select a location type.');
        return false;
    }
    else {

        //  have results, so forward to the results page
        cleanLocationCookies();
        window.location.href = '/patient-resources/find-a-location/locations-search-result/?locationtype=' + encodeURI(locationTypeValue) + "#contentTop";

    }
}

// Expose location search functions globally
window.handleLocationSearch = handleLocationSearch;
window.handleLocationTypeSearch = handleLocationTypeSearch;
window.pinSymbol = pinSymbol;


